


















import './KisweInfoBox.scss'
import { defineComponent } from '@vue/composition-api'
import useFlexbox from '../../compositions/flexbox'
import { FlexboxDirection } from '../../types/flexbox'
import { KeyDict } from '@/types'

export default defineComponent({
  name: 'KisweInfoBox',
  props: {
    ...useFlexbox({ direction: FlexboxDirection.Column }).props,
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    headerClassName (): KeyDict<boolean> {
      return {
        'kiswe-container': true
      }
    },
    bodyClassName (): KeyDict<boolean> {
      return {
        'body': true,
        'kiswe-container': this.isContainer
      }
    }
  }
})
